/** @jsx jsx */
import { jsx, Spinner } from "theme-ui";
import { useState, useCallback } from "react";
import PropTypes from "prop-types";
import { useFirebase } from "react-redux-firebase";

import { useDropzone } from "react-dropzone";
import { Modal } from "gatsby-plugin-hfn-profile/components/Modal";
import { ActionButton, Stack } from "office-ui-fabric-react";
import { useLang } from "./LanguageSelector";

const { shade4, shade0 } = require("./json/colors.json");

function MyDropzone({ onDrop, strClick }) {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });
  const [getLangString] = useLang();

  return (
    <div {...getRootProps()}>
      <input {...getInputProps()} />
      <div
        sx={{
          cursor: "pointer",
          width: "100%",
          bg: shade4,
          color: shade0,
          textAlign: "center",
          fontWeight: "600",
          fontSize: "14px",
          "&:hover": {
            opacity: 0.8,
            fontWeight: 700,
          },
        }}
      >
        <div sx={{ py: 4 }}>
          {!!strClick && strClick}
          {!strClick &&
            (isDragActive
              ? getLangString("strings.drop_file")
              : getLangString("strings.select_file"))}
        </div>
      </div>
    </div>
  );
}

MyDropzone.propTypes = {
  onDrop: PropTypes.func.isRequired,
  onDiscard: PropTypes.func.isRequired,
  strClick: PropTypes.string,
};
MyDropzone.defaultProps = {
  strClick: undefined,
};
// Path within Database for metadata (also used for file Storage path)

function Uploader({
  dbKey,
  filesPath,
  dbPath,
  docExtradata,
  docId,
  onUpload,
  onDiscard,
  strClick,
}) {
  const firebase = useFirebase();
  //   const uploadedFiles = useSelector(
  //     ({ firebase: { data } }) => data[filesPath]
  //   );
  const [uploaded, setUploaded] = useState(0);
  const [getLangString] = useLang();

  const onFilesDrop = useCallback(
    (files) => {
      setUploaded(1);
      return firebase
        .uploadFiles(filesPath, files, dbPath, {
          metadataFactory: (uploadRes, firebase1, metadata, downloadURL) => {
            const {
              metadata: { name, fullPath },
            } = uploadRes;
            return {
              [dbKey]: { downloadURL, fullPath, fileName: name },
              ...docExtradata,
            };
          },

          documentId: docId,
        })
        .then(() => {
          onUpload();
        });
    },
    [dbKey, dbPath, docExtradata, filesPath, firebase, docId, onUpload]
  );

  //   const onFileDelete = useCallback(
  //     (file, key) => {
  //       return firebase.deleteFile(file.fullPath, `${filesPath}/${key}`);
  //     },
  //     [filesPath]
  //   );

  return (
    <Modal handleClose={null}>
      <div>
        {uploaded === 0 && (
          <MyDropzone onDrop={onFilesDrop} strClick={strClick} />
        )}
        {uploaded === 1 && (
          <Stack
            horizontal
            verticalAlign="center"
            tokens={{ childrenGap: 20, padding: "10px" }}
          >
            <Spinner /> {getLangString("strings.uploading_file")}{" "}
          </Stack>
        )}
        {uploaded !== 1 && (
          <Stack horizontalAlign="center">
            <ActionButton
              text={getLangString("buttons.cancel")}
              onClick={onDiscard}
              iconProps={{ iconName: "Cancel" }}
            />
          </Stack>
        )}
        {/* {uploadedFiles && (
        <div>
          <h3>Uploaded file(s):</h3>
          {map(uploadedFiles, (file, key) => (
            <div key={file.name + key}>
              <span>{file.name}</span>
              <button onClick={() => onFileDelete(file, key)}>
                Delete File
              </button>
            </div>
          ))}
        </div>
      )} */}
      </div>
    </Modal>
  );
}

Uploader.propTypes = {
  dbKey: PropTypes.string.isRequired,
  filesPath: PropTypes.string.isRequired,
  dbPath: PropTypes.string.isRequired,
  docId: PropTypes.string.isRequired,
  onUpload: PropTypes.func.isRequired,
  onDiscard: PropTypes.func.isRequired,
  docExtradata: PropTypes.shape({}).isRequired,
  strClick: PropTypes.string,
};
Uploader.defaultProps = {
  strClick: undefined,
};

export default Uploader;
